import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {MessageModel} from '../../../../../../libs/shared/core/src/models/api/messageModel';
import {SimpleDropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {SimpleDropdownItem} from '../../../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdownItem';
import {SeenPill} from '../../../../../../libs/shared/ui/src/components/pill/seenPill';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Props.
 */

export interface MessageViewerChatSeenProps {
  message: MessageModel;
  chatUserName?: string;
  hasSmallPill?: boolean;
}

/*
 * Component.
 */

export const MessageViewerChatSeen: FC<MessageViewerChatSeenProps> = (props) => {
  const {message, chatUserName} = props;

  if (!message.isSeen) {
    return null;
  }

  return (
    <PopoverCoordinator
      renderButton={() => renderSeenButton(Boolean(props.hasSmallPill))}
      renderModal={(modalProps) => renderDropdown(modalProps, chatUserName)}
      shouldHoverWhenOpen
    />
  );
};

/*
 * Dropdown.
 */

function renderSeenButton(hasSmallPill: boolean) {
  return <SeenPill size={hasSmallPill ? VisualSizesEnum.SMALL : VisualSizesEnum.MEDIUM} />;
}

function renderDropdown(props: PopoverTransferProps, chatUserName?: string) {
  const chatUserDisplayName = chatUserName ?? 'chat visitor';
  return (
    <SimpleDropdown {...props} placement="bottom-end">
      <SimpleDropdownItem>
        <Trans id="chat-visitor-seenby">Seen by {chatUserDisplayName}</Trans>
      </SimpleDropdownItem>
    </SimpleDropdown>
  );
}
